import {
  countries
} from '../helpers/countries';

import {
  schoolBoardSchools, schoolFields
} from '../helpers/schools';

import {
  applicantFields, legalGuardianFields, premiumField, overridePremiumFields, splitPolicyButton
} from '../helpers/fields';

import * as fieldGroups from '../helpers/fieldGroups';

const clientName = 'studentaccidentplan';

export function expandedGroups() {
  return [
    fieldGroups.policyGroup(clientName, 'Referrer'),
    fieldGroups.primaryApplicantDetailsGroup(clientName),
    fieldGroups.emailNotificationGroup(),
    fieldGroups.feeRefundGroup(),
    fieldGroups.contactDetailsGroup(clientName),
    fieldGroups.dependentDetailsGroup(clientName),
    fieldGroups.coverageDetailsGroup(clientName),
    fieldGroups.pmqGroup(),
    fieldGroups.detailedBeneficiaryGroup(),
    fieldGroups.paymentGroup(clientName),
    fieldGroups.fulfillmentGroup(),
    fieldGroups.renewalGroup(),
    fieldGroups.historyGroup(),
    fieldGroups.notesGroup(),
  ];
}

export function fields() {
  return {
    policy_fields: [{
        key_path: ['application', 'additional_data', 'school'],
        as: 'Name of School Board',
        is_static_by_default: true,
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'school'],
          value: 'other'
        }]
      },
      {
        key_path: ['application', 'additional_data', 'school_other'],
        as: 'Name of School Board',
        is_static_by_default: true,
        show_if: [{
          key_path: ['application', 'additional_data', 'school'],
          value: 'other'
        }]
      }
    ],
    primary_applicant_fields: [
      ...schoolBoardSchools('0'),
      ...schoolFields('0')
    ],
    dependent_fields: [
      ...applicantFields('*', [{
          value: 'sibling',
          text: 'Sibling'
        },
        {
          value: 'other',
          text: 'Other'
        }
      ]),
      ...schoolBoardSchools('*'),
      ...schoolFields('*'),
      ...splitPolicyButton()
    ],
    contact_details_fields: legalGuardianFields(false),
    coverage_fields: [{
        key_path: ['application', 'additional_data', 'coverage_type'],
        as: 'Plan Name',
        type: 'dropdown',
        options: [{
            value: 'lite',
            text: 'Lite'
          },
          {
            value: 'plus',
            text: 'Plus'
          },
          {
            value: 'premium',
            text: 'Premium'
          },
        ],
        is_static_by_default: true
      },
      {
        key_path: ['application', 'additional_data', 'other_plan'],
        as: 'Other Insurance',
        type: 'dropdown',
        options: [{
            value: 'yes',
            text: 'Yes'
          },
          {
            value: 'no',
            text: 'No'
          }
        ],
        do_not_show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: undefined
        }]
      },
      {
        key_path: ['application', 'additional_data', 'name_of_other_plan'],
        as: 'Name of Other Plan',
        show_if: [{
          key_path: ['application', 'additional_data', 'other_plan'],
          value: 'yes'
        }]
      }
    ],
    payment_fields: overridePremiumFields()
  }
}



// WEBPACK FOOTER //
// ./src/clients/studentaccidentplan.js